import * as _React from 'react';
import * as _ReactDOM from 'react-dom';
import * as _ReactRedux from 'react-redux';
import * as _ReactReduxPure from 'react-redux-pure';

export const React = _React;
export const render = _ReactDOM.render;
export const Component = _React.Component;
export const Connect = _ReactRedux.connect as any;
export const PureConnect = _ReactReduxPure.PureConnect;
export const PureFunctional = _ReactReduxPure.PureFunctional;



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/react/index.tsx